import Script from "next/script";
import { JSX } from "react";

export default function CookieYes(): JSX.Element {
  const cookieYesId =
    process.env.NEXT_PUBLIC_COOKIEYES_ID || "8231e13877861f528459638e";
  const url = `https://cdn-cookieyes.com/client_data/${cookieYesId}/script.js`;

  if ("true" === process.env.NEXT_PUBLIC_DISABLE_YAHOO_PRIVACY) {
    return <Script id="cookieyes" src={url} strategy="afterInteractive" />;
  } else {
    return <></>;
  }
}
